import React, { Component } from "react";
import { Switch } from "react-router-dom";
import Login from "./scenes/Login";
import Home from "./scenes/Home";
import Clock from "./scenes/Clock";
import Profile from "./scenes/Profile";
import Admin from "./scenes/Admin";
import Tools from "./scenes/Tools";
import Inventory from "./scenes/Inventory";
import PublicRoute from "./components/PublicRoute";
import PrivateRoute from "./components/PrivateRoute";
import PermissionRoute from "./components/PrivateRoute";

import { renderToStaticMarkup } from "react-dom/server";
import { withLocalize } from "react-localize-redux";
import globalTranslations from "./translations/global.json";
import moment from "moment";
import "moment/locale/de";
import DefaultLayout from "./scenes/Default";

const onMissingTranslation = ({ defaultTranslation }) => defaultTranslation;

class App extends Component {


	constructor(props) {
		super(props);

		let defaultLanguage = "en";
		moment.locale(defaultLanguage);

		this.props.initialize({
			languages: [
				{name: "English", code: "en"},
				{name: "Deutsch", code: "de"},
				{name: "Français", code: "fr"}
			],
			translation: globalTranslations,
			options: {renderToStaticMarkup, defaultLanguage, onMissingTranslation}
		});

		const {setActiveLanguage} = props;

		setActiveLanguage(localStorage.getItem("defaultLanguage") || "de");
      moment.locale(localStorage.getItem("defaultLanguage") || "de");

  }

	render() {
		return (
			<div className="app" style={{height: "100%"}}>
				<main style={{height: "100%"}}>
					<Switch>
						<PrivateRoute exact path='/' component={Home}/>
						<PublicRoute path="/login" component={Login}/>
						<DefaultLayout>
							<Switch>
								<PrivateRoute path='/admin' component={Admin}/>
								<PrivateRoute path='/profile' component={Profile}/>
								<PrivateRoute path='/clock' component={Clock}/>
								<PermissionRoute path='/inventory' component={Inventory} permission={"stockTaking"}/>
                  <PrivateRoute path='/tools' component={Tools}/>
							</Switch>
						</DefaultLayout>
					</Switch>
				</main>
			</div>
		);
	}
}


export default withLocalize(App);



// WEBPACK FOOTER //
// ./src/App.js